module.exports = __webpack_public_path__ + "static/media/GUJRATI-POST-1.6f6fc2cb.jpg";